import TextInput from '-/components/fields/TextInput';

class NameInput extends TextInput {
    getErrors(label = '') {
        const errors = super.getErrors(label);

        const {value} = this;

        if (value) {
            if (value.trim().split(' ').length <= 1) {
                return ['You must enter your first and last name'];
            } else if (!/^[a-zA-Z '-]+$/.test(value)) {
                return ['Please enter only letters, spaces, apostrophes and dashes for your name'];
            }
        }

        return errors;
    }
}

export default NameInput;
